import { showSuccessAlert } from "../../constants/alerts";
import { ReportsActionTypes } from "./constants";

const INIT_STATE = {
  rentalsReport: [],
  locationsReport: [],
  revenueReport: [],
  pagination: null,
  initialLoading: false,
  loading: false,
  error: null,
};

interface ReportsActionType {
  type:
    | ReportsActionTypes.API_RESPONSE_SUCCESS
    | ReportsActionTypes.API_RESPONSE_ERROR
    | ReportsActionTypes.GET_RENTALS_REPORT
    | ReportsActionTypes.GET_REVENUE_REPORT
    | ReportsActionTypes.GET_LOCATION_REPORT;

  payload: {
    actionType?: string;
    data?: any | {};
    error?: string;
  };
}

const Reports = (state: any = INIT_STATE, action: ReportsActionType): any => {
  switch (action.type) {
    case ReportsActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case ReportsActionTypes.GET_RENTALS_REPORT: {
          return {
            ...state,
            rentalsReport: action.payload.data?.report || action.payload.data,
            pagination: action.payload.data?.pagination || null,
            initialLoading: false,
            loading: false,
            error: null,
          };
        }

        case ReportsActionTypes.GET_LOCATION_REPORT: {
          return {
            ...state,
            locationsReport: action.payload.data.report,
            rentalsReport: action.payload.data.locationWiseReport,
            loading: false,
            initialLoading: false,
            error: null,
          };
        }

        case ReportsActionTypes.GET_REVENUE_REPORT: {
          return {
            ...state,
            revenueReport: action.payload.data,
            loading: false,
            initialLoading: false,
            error: null,
          };
        }

        default:
          return { ...state };
      }

    case ReportsActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case ReportsActionTypes.GET_RENTALS_REPORT:
        case ReportsActionTypes.GET_REVENUE_REPORT:
        case ReportsActionTypes.GET_LOCATION_REPORT: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }

        default:
          return { ...state };
      }

    case ReportsActionTypes.GET_RENTALS_REPORT:
    case ReportsActionTypes.GET_REVENUE_REPORT:
    case ReportsActionTypes.GET_LOCATION_REPORT:
      return {
        ...state,
        initialLoading: true,
        error: null,
      };

    default:
      return { ...state };
  }
};

export default Reports;
